const e = {
  name: "NumberFiveCircleFilled",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<path class="st0" d="M0,20C0,9,9,0,20,0s20,9,20,20s-9,20-20,20S0,31,0,20z M24,16v-2h-8v7h6v3h-6v2h8v-7h-6v-3H24z"/>
</svg>
  `
};
export {
  e as NumberFiveCircleFilled
};
